import { render, staticRenderFns } from "./myHospital.vue?vue&type=template&id=7cbbfa19&scoped=true"
import script from "./myHospital.vue?vue&type=script&lang=js"
export * from "./myHospital.vue?vue&type=script&lang=js"
import style0 from "./myHospital.vue?vue&type=style&index=0&id=7cbbfa19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbbfa19",
  null
  
)

export default component.exports